import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
moment.locale("es");

const cuentasPorCobrarMailPdf = (values) => {
    const empresa = values.empresa;
    const logoBiwo = values.logoBiwo;

    let saldosAFavor = []
    let ventas = []

    let totalTotales = 0
    let totalAbonos = 0
    let totalSaldo = 0
    let totalVencido = 0
    let totalNoVencido = 0


    let grupos = [];
    let grupoActual = [];

    for (const venta of values.ventas) {
        const esVentaPrincipal = venta.folio && typeof venta.fechaFactura === 'string';

        if (esVentaPrincipal) {
            if (grupoActual.length > 0) {
                grupos.push(grupoActual);
            }
            grupoActual = [venta];
        } else {
            grupoActual.push(venta);
        }
    }

    if (grupoActual.length > 0) {
        grupos.push(grupoActual);
    }


    grupos.sort((a, b) => {
        const fechaA = moment(a[0].fechaFactura, "DD/MM/YYYY").toDate();
        const fechaB = moment(b[0].fechaFactura, "DD/MM/YYYY").toDate();
        return fechaA - fechaB;
    });


    values.ventas = grupos.flat();



    for (const valueVenta of values.ventas) {
        if (valueVenta.saldoAFavor) {
            // const properties = valueVenta.colorStyle ? { background: valueVenta.colorStyle } : {}

            saldosAFavor.push([
                { text: valueVenta.folio, style: 'textoTabla', alignment: 'left' },
                { text: isNaN(valueVenta.fechaFactura) ? moment(valueVenta.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' },
                { text: valueVenta.cliente, style: 'textoTabla', alignment: 'left' },
                // {
                //     text: typeof valueVenta.fechaVencimiento === 'string' &&
                //         moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid()
                //         ? moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L')
                //         : '',  // <- aquí se pone vacío si la fecha no es válida
                //     style: 'textoTabla',
                //     alignment: 'center'
                // },
                // { text: valueVenta.estado, ...properties, style: 'textoTabla', alignment: 'left' },
                // { text: valueVenta.vendedor, style: 'textoTabla', alignment: 'left' },
                { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(valueVenta.anticipo ? valueVenta.totalPagadoAnticipos : valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
            ])
        } else {
            const properties = valueVenta.colorStyle ? { background: valueVenta.colorStyle } : {}
            totalTotales += valueVenta.total
            totalAbonos += valueVenta.totalPagado
            totalSaldo += valueVenta.saldo

            if (typeof valueVenta.fechaVencimiento === 'string' && moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid()) {
                if (moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").isBefore(moment())) {
                    totalVencido += valueVenta.saldo
                } else {
                    totalNoVencido += valueVenta.saldo
                }
            }

            ventas.push([
                { text: valueVenta.folio + (valueVenta.ordenDeCompra ? ("\nOC: " + valueVenta.ordenDeCompra) : ""), style: 'textoTabla', alignment: 'left' },
                { text: isNaN(valueVenta.fechaFactura) ? moment(valueVenta.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' },
                { text: valueVenta.cliente, style: 'textoTabla', alignment: 'left' },
                {
                    text: typeof valueVenta.fechaVencimiento === 'string' &&
                        moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid()
                        ? moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L')
                        : '-',
                    style: 'textoTabla',
                    alignment: 'center'
                },
                { text: valueVenta.estado, ...properties, style: 'textoTabla', alignment: 'left' },
                // { text: valueVenta.vendedor, style: 'textoTabla', alignment: 'left' },
                { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
            ])
        }
    }

    if (totalTotales > 0 || totalAbonos > 0 || totalSaldo > 0) {
        ventas.push([
            { text: 'Totales:', style: 'totalesTabla', alignment: 'left', colSpan: 5 },
            {},
            {},
            {},
            {},
            // {},
            { text: dineroDisabledMask(totalTotales), style: 'totalesTabla', alignment: 'right' },
            { text: dineroDisabledMask(totalAbonos), style: 'totalesTabla', alignment: 'right' },
            { text: dineroDisabledMask(totalSaldo), style: 'totalesTabla', alignment: 'right' },
        ], [
            { text: 'Total Vencido:', style: 'totalesTabla', alignment: 'left', colSpan: 5 },
            {},
            {},
            {},
            {},
            // {},
            { text: dineroDisabledMask(totalVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
            {},
            {},
        ], [
            { text: 'Total No Vencido:', style: 'totalesTabla', alignment: 'left', colSpan: 5 },
            {},
            {},
            {},
            {},
            // {},
            { text: dineroDisabledMask(totalNoVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
            {},
            {},
        ])
    }

    
    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                //							rowSpan: 3,
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                                //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                            },
                            {
                                //	rowSpan: 2,
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [
                                            {
                                                text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno),
                                                style: "tableHeader"
                                            }
                                        ],
                                        [
                                            {
                                                text: "R.F.C: " + empresa.rfc,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.calle + ' ' +
                                                    empresa.numeroCalle + ' ' +
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.colonia.tipoAsentamiento + ' ' +
                                                    empresa.colonia.nombre + ' C.P. ' +
                                                    empresa.colonia.cp + ' ' +
                                                    empresa.municipio.nombre + ' ' +
                                                    empresa.estado.abreviatura + ' ' +
                                                    empresa.pais.abreviatura + ' '
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [{ text: 'ESTADO DE CUENTA CLIENTE', style: 'tableHeader' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        [{ text: 'Desglose:', style: 'subheader', alignment: 'center' }],
                                        [{ text: values.detalle ? 'Si' : 'No', style: 'textoChico', alignment: 'center' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]

                    ]
                },
            },
           
            [{ text: 'SALDOS A FAVOR', style: 'tableHeader' }],
            {
                style: 'tableExample',
                table: {
                    widths: ['10%', '10%', '46%', '10%', '10%', '14%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Cliente', style: 'tituloTabla' },
                            // { text: 'Vencimiento', style: 'tituloTabla' },
                            // { text: 'Estado', style: 'tituloTabla' },
                            // { text: 'Vendedor', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Abonos', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                        ],
                        //Falta esto en el backend y ya
                        ...saldosAFavor,
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }
            },

            [{ text: 'FACTURAS PENDIENTES', style: 'tableHeader' }],
            {
                style: 'tableExample',
                table: {
                    widths: ['8%', '10%', '28%', '10%', '10%', '10%', '10%', '14%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Cliente', style: 'tituloTabla' },
                            { text: 'Vencimiento', style: 'tituloTabla' },
                            { text: 'Estado', style: 'tituloTabla' },
                            // { text: 'Vendedor', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Abonos', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                        ],
                        //Falta esto en el backend y ya
                        ...ventas,
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }
            },

        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico: {
                fontSize: 8
            },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: '#cccccc',
                style: 'subheader',
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            },
            totalesTabla: {
                fontSize: 8,
                bold: true,
                italics: false,
                fillColor: '#cccccc',
            }
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
    }
    return dd;
}

export default  cuentasPorCobrarMailPdf;
